import type { ScoreUnit } from '../types';

import { parseFindings } from './parseFindings';
import { parsePatterns } from './parsePatterns';

export function schoolResidualCount(
  candidateSchoolNames: string[],
  findingsText: string,
  unit: ScoreUnit,
): number {
  if (unit === 'proficiency_level') return 0;
  if (parseFindings(findingsText).length === 0) return 0;

  const distinct = [...new Set(candidateSchoolNames)].filter(Boolean);
  const byLengthDesc = [...distinct].sort((a, b) => b.length - a.length);
  let masked = findingsText;
  const covered = new Set<string>();
  for (const name of byLengthDesc) {
    if (masked.includes(name)) {
      covered.add(name);
      masked = masked.split(name).join(' ');
    }
  }
  return distinct.length - covered.size;
}

export function hasResidualSubgroupPatterns(
  candidateCount: number,
  patternsText: string,
  unit: ScoreUnit,
): boolean {
  if (unit === 'proficiency_level') return false;
  return candidateCount > parsePatterns(patternsText).length;
}
